<template>
  <router-view />
</template>

<script>


export default {
  name: 'App',
  components: { 
    
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  border: 0;
  scroll-behavior: smooth; //平滑滚动
}

html, body {
  width: 100%;
  overflow-x: hidden; // 防止横向滚动
}

#app {
  width: 100%;
  min-width: 0; // 防止内容溢出
}

/* 移动端全局优化 */
@media screen and (max-width: 768px) {
  body {
    font-size: 14px;
  }
  
  /* 确保所有固定宽度容器在移动端自适应 */
  [style*="width: 1200px"],
  [style*="width:1200px"] {
    width: 100% !important;
    padding: 0 10px;
    box-sizing: border-box;
  }
  
  /* Element UI 组件在移动端优化 */
  .el-col {
    width: 100% !important;
  }
  
  .el-row {
    margin: 0 !important;
  }
  
  /* 表格在移动端优化 */
  .el-table {
    font-size: 12px;
  }
  
  /* 对话框在移动端优化 */
  .el-dialog {
    width: 95% !important;
    margin: 5vh auto !important;
  }
  
  /* 分页组件在移动端优化 */
  .el-pagination {
    transform: scale(0.9);
  }
}
</style>
